import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";

class DashboardCard extends Component {
  render() {
    return (
      <React.Fragment>
        <Card className="mini-stat bg-pattern">
          <CardBody className="mini-stat-img">
            <div className="mini-stat-icon">
              <i
                className={`bg-soft-primary text-primary float-right h4 ${this.props.icon}`}
              ></i>
            </div>
            <h6 className="text-uppercase mb-3 mt-0">{this.props.title}</h6>
            <h5 className="mb-3">{this.props.count}</h5>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default DashboardCard;
